import React, { useEffect, useState } from "react";
import { config } from "../../config";
import "../Shopkeeper/css/pricing.css";

import { Link, useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { BsQuestionOctagon } from "react-icons/bs";

export default function Pricing() {
  const [pricing, setPricing] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [error, setError] = useState(null);
  const [showYearly, setShowYearly] = useState(false); // toggle state

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  // Fetch shop promotions
  const fetchShopPromotions = async () => {
    const access_token = localStorage.getItem("accessToken");
    const userId = localStorage.getItem("userId");

    const url = `${config.api_base}api/v2/bcf11870-f401-427e-b940-1758c5a79540/shop/${userId}/promotion?page=0&offset=100&type=ALL`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch promotions");

      const data = await response.json();
      console.log("Promotions:", data);
      setPromotions(data);
    } catch (err) {
      console.error("Error fetching promotions:", err);
      setError(err.message);
    }
  };

  // Fetch pricing plans
  const fetchPricingPlans = async () => {
    const access_token = localStorage.getItem("accessToken");

    const url = `${config.api_base}api/v2/subscription/plans`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch pricing plans");

      const data = await response.json();
      console.log("Pricing Plans:", data);
      setPricing(data);
    } catch (err) {
      console.error("Error fetching pricing plans:", err);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchShopPromotions();
    fetchPricingPlans();
  }, []);

  // logout handling
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const confirmLogout = () => {
    handleLogout();
    handleClose();
  };

  // helper: show readable type
  const getTypeLabel = (type) => {
    switch (type?.toLowerCase()) {
      case "monthly":
        return "month";
      case "weekly":
        return "week";
      case "daily":
        return "day";
      case "yearly":
        return "year";
      default:
        return type;
    }
  };

  // Filter logic for plans
   const filteredPlans = pricing.filter((plan) => {
    if (showYearly) {
      return plan.type?.toLowerCase() === "yearly";
    } else {
      return plan.type?.toLowerCase() !== "yearly"; // monthly + weekly + daily
    }
  });
  return (
    <>
      <div className="wrapper">
        {/* ===== HEADER ===== */}
       <div className="main-header">
            <div className="logo-header text-center">
              <a href="https://adoop.in/" target="_blank">
                <img
                  src="assets/img/logo/adoop-png.png"
                  style={{ width: "100px" }}
                  alt="logo"
                />
              </a>
              <button
                className="navbar-toggler sidenav-toggler ml-auto"
                type="button"
                data-toggle="collapse"
                data-target="collapse"
                aria-controls="sidebar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <button className="topbar-toggler more">
                <i className="la la-ellipsis-v"></i>
              </button>
            </div>
            <nav className="navbar navbar-header navbar-expand-lg">
              <div className="container-fluid">
                <form
                  className="navbar-left navbar-form nav-search mr-md-3"
                  action=""
                >
                  {/* <div className="input-group">
                    <input
                      type="text"
                      placeholder="Search ..."
                      className="form-control"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i className="fas fa-search"></i>
                      </span>
                    </div>
                  </div> */}
                </form>
                <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                  <li className="nav-item dropdown">
                    <a
                      className="profile-pic"
                      href="#"
                      aria-expanded="false"
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        src={`https://d3p6cw3ny59ckg.cloudfront.net/store/${promotions.shop?.logo}`}
                        alt="user-img"
                        width="36"
                        className="img-circle"
                      />
                      <span>
                        Hello, {promotions?.shop?.name || "Shopkeeper"}
                      </span>{" "}
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                      <li>
                        <div className="user-box">
                          <div className="u-img">
                            <img src="assets/img/profile.jpg" alt="user" />
                          </div>
                          <div className="u-text">
                            <h4> {promotions?.shop?.name || "Shopkeeper"}</h4>
                            <p className="text-muted">kktannu60@.com</p>
                            <a
                              href="profile.html"
                              className="btn btn-rounded btn-danger btn-sm"
                            >
                              View Profile
                            </a>
                          </div>
                        </div>
                      </li>
                      <div className="dropdown-divider"></div>
                      <a className="dropdown-item" href="#">
                        <i className="ti-user"></i> My Profile
                      </a>
                      <a className="dropdown-item" href="#">
                        {" "}
                        My Balance
                      </a>
                      <a className="dropdown-item" href="#">
                        <i className="ti-email"></i> Inbox
                      </a>
                      <div className="dropdown-divider"></div>

                      <a className="dropdown-item" href="#">
                        <i className="fa fa-power-off"></i> Logout
                      </a>
                    </ul>
                    {/* <!-- /.dropdown-user --> */}
                  </li>
                </ul>
              </div>
            </nav>
          </div>

        {/* ===== SIDEBAR ===== */}
       <div className="sidebar">
                 <div className="scrollbar-inner sidebar-wrapper">
                   <ul className="nav">
                     <li className="nav-item">
                       <Link to="/shophome" style={{textDecoration:"none"}}>
                         <i class="fa-solid fa-house"></i>
                         <p>Home</p>
                       </Link>
                     </li>
                     <li className="nav-item">
                       <Link to="/addpromotions" style={{textDecoration:"none"}}>
                       <i class="bi bi-megaphone-fill"></i> 
                         <p>Promo</p>
                       </Link>
                     </li>
                     <li className="nav-item">
                       <Link to="/shopProfile" style={{textDecoration:"none"}}>
                         <i class="bi bi-person-fill"></i>
                         <p>Profile</p>
                       </Link>
                     </li>
                      <li className="nav-item active">
                                     <Link to="/shopPricing" style={{ textDecoration: "none" }}>
                                       <i class="bi bi-cash"></i>
                                       <p>My Subscription</p>
                                     </Link>
                                   </li>
                     <li className="nav-item">
            <Link
                       to="#"
                       onClick={handleShow}
                       style={{ textDecoration: "none" }}
                     >
                       <i className="fa-solid fa-right-from-bracket"></i>
                       <p>Logout</p>
                     </Link>
     
                     {/* React Bootstrap Modal */}
                     <Modal
                       show={showModal}
                       onHide={handleClose}
                       size="sm"
                       // centered
                       dialogClassName="custom-logout-modal"
                     >
                       <Modal.Header closeButton className="modal-header-warning">
                         <Modal.Title style={{ fontSize: "18px", color: "#fff" }}>
                           Sign Out
                         </Modal.Title>
                       </Modal.Header>
                       <Modal.Body className="d-flex align-items-center gap-2">
                         <BsQuestionOctagon size={20} className="text-dark" />
                         <span>Do you really want to sign out?</span>
                       </Modal.Body>
                       <Modal.Footer className="justify-content-end">
                         <Button
                           variant="outline-secondary"
                           className="btn-no"
                           onClick={handleClose}
                         >
                           No
                         </Button>
                         <Button
                           variant="light" // prevents default "primary" background
                           className="btn-yes ms-2"
                           style={{
                             backgroundColor: "#ffc600",
                             border: "none",
                             color: "black",
                           }}
                           onClick={confirmLogout}
                         >
                           Yes
                         </Button>
                       </Modal.Footer>
                     </Modal>
         </li>
                   </ul>
                 </div>
               </div>

        {/* ===== MAIN PANEL ===== */}
        <div className="main-panel">
          <div className="content">
            <div className="container-fluid bg-white p-3 rounded mb-4">
              <h4 className="page-title">Pricing List</h4>

              <section id="pricing" className="pricing section">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                  {/* Toggle */}
                  <div
                    className="pricing-toggle-container mb-5"
                    data-aos="zoom-in"
                    data-aos-delay="150"
                  >
                    <div className="pricing-toggle d-inline-flex align-items-center gap-3 px-3 py-2 rounded-pill">
                      <span className={!showYearly ? "active" : ""}>Monthly</span>
                      <label className="switch m-0">
                        <input
                          type="checkbox"
                          aria-label="Toggle pricing"
                          checked={showYearly}
                          onChange={() => setShowYearly(!showYearly)}
                        />
                        <span className="slider"></span>
                      </label>
                      <span className={showYearly ? "active" : ""}>Yearly</span>
                    </div>
                  </div>

                  {/* Pricing Cards */}
                  <div className="row gy-4">
                    {filteredPlans.map((plan, index) => (
                      <div className="col-lg-4" key={plan.id}>
                        <article
                          className={`price-card h-100 ${
                            index === 1 ? "featured" : ""
                          }`}
                        >
                          <div className="card-head">
                            <span className="badge-title">{plan.name}</span>
                            <h3 className="title">{plan.name} Plan</h3>
                            <p
                              className="subtitle"
                              style={{ color: "var(--default-color)" }}
                            >
                              {plan.ads_limit}
                            </p>
                            <div className="price-wrap">
                                                                                    <span className="price price-monthly">
  <span style={{ textDecoration: 'line-through', color: '#888', marginRight: '8px' }}>
    Rs.{plan.amount}
  </span>
  <span>
    {/* Rs.{plan.discount_amount} / {getTypeLabel(plan.type)} */}
    Rs.{plan.discount_amount}
  </span>
</span>
                            </div>
                          </div>

                          <ul className="feature-list list-unstyled mb-4">
                            <li>
                              <i className="bi bi-check-circle"></i> Validity:{" "}
                              {plan.validity} days
                            </li>
                            <li>
                              <i className="bi bi-check-circle"></i> Per Day:{" "}
                              {plan.ads}
                            </li>
                            <li>
                              <i className="bi bi-check-circle"></i> Total Ads:{" "}
                              {plan.total_ads}
                            </li>
                            <li>
                              <i className="bi bi-check-circle"></i>Plan Type:{" "}
                              {getTypeLabel(plan.type)}
                            </li>
                          </ul>

                          <div className="cta">
                            <a
                              href="https://mercury-uat.phonepe.com/transact/uat_v2?token=sampleToken"
                              className="btn btn-choose w-100"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Choose {plan.name}
                            </a>
                          </div>
                        </article>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Logout Modal ===== */}
      <Modal
        show={showModal}
        onHide={handleClose}
        size="sm"
        dialogClassName="custom-logout-modal"
      >
        <Modal.Header closeButton className="modal-header-warning">
          <Modal.Title style={{ fontSize: "18px", color: "#fff" }}>
            Sign Out
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex align-items-center gap-2">
          <BsQuestionOctagon size={20} className="text-dark" />
          <span>Do you really want to sign out?</span>
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
          <Button variant="outline-secondary" className="btn-no" onClick={handleClose}>
            No
          </Button>
          <Button
            variant="light"
            className="btn-yes ms-2"
            style={{
              backgroundColor: "#ffc600",
              border: "none",
              color: "black",
            }}
            onClick={confirmLogout}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
